'use client';

import { twMerge } from 'tailwind-merge';
import { isBrowser } from '../../../utils/isBrowser';
import { useState } from 'react';

export default function MobileNavigationButton() {

  const [mounted, setMounted] = useState(false);

  const handleClick = () => {
    if (!isBrowser()) return;
    setMounted(true);
    const target = document.querySelector<HTMLElement>('.related-posts');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  if (!mounted) return null;

  return (
      <div onClick={() => handleClick()} className={twMerge('desktop:hidden rounded-[6px] grid place-items-center w-fit px-[12px] h-[36px] cursor-pointer transition-all duration-300 hover:scale-[103%] bg-gray-100 dark:bg-quaternary self-start')}>
      <span className='text-dark dark:text-white h6'>المزيد</span>
    </div>
  )
}